var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25910",
    d: "M3 3C3 2.44772 3.44772 2 4 2H12C12.5523 2 13 2.44772 13 3V13.8079C13 13.8888 12.9089 13.9363 12.8427 13.8899L8.05735 10.5401C8.02291 10.516 7.97709 10.516 7.94265 10.5401L3.15735 13.8899C3.09107 13.9363 3 13.8888 3 13.8079V3Z",
    stroke: "currentColor",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.506847b6f47e6f65c4b1fdc6a012cd2e.svg";
export { ForwardRef as ReactComponent };